// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5cfb2634","69":"88a8bf43","137":"47be6b24","167":"12934610","287":"99de424e","369":"5b8b8754","568":"165d3c60","670":"fbb4a118","921":"c8c59c8c"}[chunkId] + ".chunk.js";
};